import React from 'react'
import DatePicker from './DatePicker'

type Props = {
  label?: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  type?: React.HTMLInputTypeAttribute
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode']
  autoComplete?: string
  onFocus?: React.FocusEventHandler<HTMLInputElement>
  onBlur?: React.FocusEventHandler<HTMLInputElement>
  disabled?: boolean
  error?: string | null
  hint?: string
  className?: string
}

export default function TextField({
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  inputMode,
  autoComplete,
  onFocus,
  onBlur,
  disabled,
  error,
  hint,
  className,
}: Props) {
  // Use DatePicker component for date inputs
  if (type === 'date') {
    return (
      <DatePicker
        label={label}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        className={className}
      />
    )
  }

  return (
    <div className={className}>
      {label ? <label className="block text-sm mb-2">{label}</label> : null}
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder={placeholder}
        inputMode={inputMode}
        autoComplete={autoComplete}
        disabled={disabled}
        className="ds-input"
      />
      {error ? <div className="text-red-600 text-sm mt-2">{error}</div> : null}
      {!error && hint ? <div className="text-sm text-gray-500 mt-2">{hint}</div> : null}
    </div>
  )
}

